"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.getInitialValue = void 0;
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getInitialValue = exports.getInitialValue = function getInitialValue() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultValueVariables = arguments.length > 1 ? arguments[1] : undefined;
  var defaultValueVariable = settings.defaultValueVariable;
  if (defaultValueVariable) {
    if (defaultValueVariables) {
      var defaultValue = (0, _get2["default"])(defaultValueVariables, defaultValueVariable);
      if (!defaultValue) {
        console.error("There is no variable \"".concat(defaultValueVariable, "\""));
      } else if (!(0, _isString2["default"])(defaultValue)) {
        console.error("The value of \"".concat(defaultValueVariable, "\" variable should be a string"));
      } else {
        return defaultValue;
      }
    }
  } else if (settings.defaultValue) {
    return settings.defaultValue;
  }
  return undefined;
};
var validate = exports.validate = function validate(value, settings) {
  var error;
  var isAnswerRequired = settings.isAnswerRequired,
    noAnswerMessage = settings.noAnswerMessage;
  var min = +settings.min;
  var max = +settings.max;
  if (isAnswerRequired && (value === undefined || !(0, _isInt["default"])(value.toString(), {
    min: min,
    max: max
  }))) {
    error = noAnswerMessage;
  }
  return error;
};